module.exports = __webpack_public_path__ + "img/16.3d07e753.jpg";